import { ListItemButton, styled } from "@mui/material";

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  padding: "11px",
  borderRadius: theme.shape.borderRadius,
  color: '#51555C',
  "&:hover": {
    background: "#F9F9FA",
    color: '#101828',
  },
  "&.Mui-selected": {
    background: "#F3F3F5",
    color: '#101828',
    "&:hover": {
      background: "#F3F3F5",
    },
  },
}));

export default StyledListItemButton;
